<div
  class="quick-search-input"
  [ngClass]="{ expanded: dialogMode || expanded, dialog: dialogMode  }"
  (clickOutside)="colapseSearchPanel()">
  <div class="search-input">
    <lib-icon class="search-icon" icon="magnifying-glass"></lib-icon>
    <input
      type="text"
      [formControl]="searchControl"
      class="input input--rounded input--placeholder-grey"
      [placeholder]="(placeholder || 'COMMON.start_search_here') | translate"
      [attr.aria-label]="(ariaLabel || placeholder) | translate"
      (focus)="expandSearchPanel()"
      (keydown.enter)="submitSearchQuery()"
      enterkeyhint="search">

    <div class="input-buttons">
      @if (searchControl?.value) {
        <button
          mat-icon-button
          class="button button--icon clear-icon"
          aria-label="Clear search"
          (click)="clearSearch()">
          <lib-icon icon="x" [size]="24"></lib-icon>
        </button>
      }

      <button mat-flat-button class="button button--transparent button--small close-button" (click)="closeSearchDialog()">
        {{ 'COMMON.cancel' | translate }}
      </button>
    </div>

  </div>

  <div class="search-quick-results">
    @if (!bundle && resultsBundles?.length) {
      <div class="divider"></div>
      <div class="chip-container">
        @for (item of resultsBundles; track item) {
          <div class="chip-item" (click)="$event.stopPropagation(); searchByBundle.emit(item)">
            {{ ('ENTITY_TYPE.' + item) | translate | titlecase }}
          </div>
        }
      </div>
    }

    @if (bundleSetInternally) {
      <div class="divider"></div>
      <div class="chip-container">
        <div class="chip-item chip-item--active" data-cy="quick-search-clear-bundle-filter" (click)="$event.stopPropagation(); clearBundleFilter()">
          {{ ('ENTITY_TYPE.' + bundle) | translate | titlecase }}
          <lib-icon icon="x" [size]="14"></lib-icon>
        </div>
      </div>
    }

    @if (!expanded && enableLastSearch && lastSearches?.length) {
      <div class="divider"></div>
      <div class="last-search-container">
        <span class="search-results-label">{{ 'SEARCH.last_search' | translate }}</span>
        <div class="last-search-list">
          @for (item of lastSearches; track item) {
            <div class="last-search" (click)="useLastSearchItem(item)">
              <span class="item-title" ellipsis [ellipsis-content]="item.search"></span>
              <lib-icon class="clear-icon" icon="x" [size]="14" (click)="clearLastSearchItem($event, item)"></lib-icon>
            </div>
          }
        </div>
      </div>
    }

    @if (expanded && enabledSearchByTag) {
      <div class="divider"></div>
      <div class="tags-quick-results">
        <span class="search-results-label">{{ 'SEARCH.with_tag' | translate }}</span>
        <div class="chip-container">
          @if (tags?.length) {
            @for (item of tags; track item) {
              <div class="chip-item" (click)="searchByTag.emit(item.id)">
                {{ item.title }}
              </div>
            }
          } @else {
            @if (tagsLoading) {
              @for (item of loadingPlaceholers; track item) {
                <lib-skeleton-loader class="chip-placeholder"></lib-skeleton-loader>
              }
            } @else {
              <span class="search-results-label tags-empty-label">{{ 'SEARCH.no_tags_found' | translate }}</span>
            }
          }
        </div>
      </div>
    }

    @if (expanded) {
      <div class="divider"></div>
      <ng-scrollbar class="results-scroll-container" [class.is-loading]="dataLoading">
        <div class="quick-results-section" [class.multiple-group]="dialogMode">
          <div class="quick-results-labels">
            <ng-container *ngTemplateOutlet="resultsHeaderTemplate || resultsHeaderTemplateDefault"></ng-container>
          </div>
          @if (dataGroups?.length) {
            @for (group of dataGroups; track group.bundle; let last = $last) {
              <div class="results-group" [class.last-group]="last">
                <label class="results-group-label">
                  {{ group.label | translate }}
                </label>
                <div class="search-results-list">
                  @for (item of group.items; track item.id) {
                    <div class="search-result">
                      <ng-container *ngTemplateOutlet="resultTemplate || resultTemplateDefault; context: { item: item}"></ng-container>
                    </div>
                  }
                </div>
                <div class="divider"></div>
              </div>
            }

            @if (bundle && enableLoadMore && hasMoreResults) {
              <div #loadMoreSentinel class="quick-results-load-more" data-cy="quick-search-load-more">
                @if (isLoadingMore) {
                  <mat-spinner [diameter]="24"></mat-spinner>
                }
              </div>
            }
          } @else {
            @if (dataLoading) {
              @for (item of loadingPlaceholers; track item) {
                <lib-skeleton-loader class="data-placeholder"></lib-skeleton-loader>
              }
            } @else {
              <span class="search-results-label data-empty-label">{{ 'COMMON.no_results' | translate }}</span>
            }
          }
        </div>
      </ng-scrollbar>
    }



    <div class="divider"></div>

    <div class="search-input-footer">

      @if (expanded && searchControl?.value) {
        <span class="search-results-label footer-results-label">{{ 'SEARCH.all_search_result_for' | translate : { key: searchControl?.value } }}</span>
        <span class="search-results-label footer-results-label enter-label">{{ 'COMMON.press_enter' | translate }}</span>
        <button class="button button--transparent button--outline mobile-only search-result-button" mat-flat-button (click)="submitSearchQuery()">
          {{ 'SEARCH.see_all_results_for' | translate : { key: searchControl?.value } }}
        </button>
      } @else if (!expanded) {
        <span class="search-results-label">{{'SEARCH.start_typing_to_see_search_results' | translate }}</span>
      }


    </div>
  </div>

</div>

<ng-template #resultsHeaderTemplateDefault>
  <div class="d-flex justify-content-between">
    <span>{{ 'COMMON.title' | translate}}</span>
  </div>
</ng-template>

<ng-template #resultTemplateDefault let-item="item">
  <div class="content-row-result" [class.locked]="item.isLocked" (click)="navigateToEntity(item)">
    <div class="content-row-result-icon">
      @switch (item.bundle) {
        @case (bundles.WEBINAR) {
          <lib-icon icon="monitor-play"></lib-icon>
        }
        @case (bundles.LIBRARY) {
          <lib-icon icon="books"></lib-icon>
        }
        @default {
          <lib-icon icon="book-open-text"></lib-icon>
        }
      }
    </div>

    <div class="content-row-result-row">
      <div class="content-row-result-name">
        <span class="item-bundle">{{ item | bundleLabel | async }}</span>
        <span class="item-title" ellipsis [ellipsis-content]="item.title"></span>
      </div>

      @if (item.isLocked) {
        <lib-icon
          icon="lock-simple"
          [size]="18"
        [matTooltip]="'ERRORS.content_locked' | translate"></lib-icon>
      }

      @if (!item.isLocked && item.payable && !item.isPaid && paymentEnabled) {
        <div
          class="content-row-result-price">
          {{ item.price }} {{item.currency | uppercase}}
        </div>
      }
    </div>
  </div>
</ng-template>
